export class SelectComponentValue {
  label: string = '';
  value: string = '';
  isActive: boolean = true;

  constructor(param: { label: string; value: string; isActive?: boolean }) {
    this.label = param.label;
    this.value = param.value;
    this.isActive = param.isActive ?? true;
  }
}
